/**
 * TCR-2075 — tài khoản có vai trò chính (`role`) + vai trò bổ sung. Quyền hiển thị menu/route đã đi
 * theo `permissions` từ /auth/me (BE hợp quyền); các helper này chỉ dành cho chỗ FE còn so TÊN vai trò:
 * - "được phép nếu là X" → `hasAnyRole` (bất kỳ vai trò nào khớp);
 * - "thu hẹp giao diện cho NV" → `allRolesIn` (chỉ khi MỌI vai trò đều thuộc tập hẹp).
 */
export type RoleHolder =
  | { role?: string | null; roles?: readonly string[] | null }
  | null
  | undefined;

export function userRolesOf(user: RoleHolder): string[] {
  const list = (user?.roles ?? []).filter((r): r is string => typeof r === 'string' && r.length > 0);
  if (list.length > 0) return [...new Set(list)];
  return user?.role ? [user.role] : [];
}

export function hasAnyRole(user: RoleHolder, allowed: Iterable<string>): boolean {
  const set = new Set(allowed);
  return userRolesOf(user).some((r) => set.has(r));
}

export function allRolesIn(user: RoleHolder, narrow: Iterable<string>): boolean {
  const set = new Set(narrow);
  const roles = userRolesOf(user);
  return roles.length > 0 && roles.every((r) => set.has(r));
}

/** Vai trò (chính + bổ sung) của 1 NV trong danh sách Tài khoản ERP. */
export function staffRolesOf(
  staff: { role?: string | null; additionalRoleAliases?: readonly string[] | null } | null | undefined,
): string[] {
  return [...new Set([staff?.role, ...(staff?.additionalRoleAliases ?? [])].filter((r): r is string => !!r))];
}
